import { PSidebarItem } from '../../types/navigation';
import { ProjectIcon } from '../../assets/Icons';
import { TrendingUp, CheckSquare } from 'lucide-react';
import { ReactComponent as TeamIcon } from '../../assets/team.svg';

export const baseProjectSidebarConfig: PSidebarItem[] = [
  {
    id: "projects-group",
    label: "Projects",
    icon: <ProjectIcon size={20} />,
    type: "item",
    isDynamic: true,
    children: [
      {
        id: "view-all-projects",
        label: "View all projects",
        path: "/:orgSlug/pmo/projects",
        type: "link",
      },
    ],
  },
  {
    id: "my-tasks",
    label: "My Tasks",
    icon: <CheckSquare size={20} />,
    path: "/:orgSlug/pmo/my-tasks",
    type: "link",
  },
  // {
  //   id: "reports-analytics",
  //   label: "Reports & Analytics",
  //   icon: <TrendingUp size={20} />,
  //   path: "/:orgSlug/pmo/reports-analytics",
  //   type: "link",
  // },
  {
    id: "team-insights",
    label: "Team Insights",
    icon: <TeamIcon />,
    path: "/:orgSlug/pmo/team-insights",
    type: "link",
  },
];

export const limitedProjectSidebarConfig: PSidebarItem[] = baseProjectSidebarConfig.filter(
  item => item.id !== 'team-insights'
);
